  import './IconsSection.css';
// import ImageShowcase from './ImageShowcase';

function IconsSection({  }) {

 

  const IconCard = ({headline,headlineMaxWidth,  text ,textMaxWidth ,imgSrc}) => (
    <div className="color-blue-dark"
    style={{
     
      display: "flex",
      flexDirection: "column",
      alignItems: "center",       // מרכז אופקית
 
    }}
     >
      <img src={imgSrc} alt="icon"  className='icon-image mb-s-15'/>
      <h3 className='mb-s-5' style={{maxWidth:headlineMaxWidth ,textAlign:"center"}}>{headline}</h3>
      <h5                    style={{ maxWidth:textMaxWidth ,textAlign:"center"}}>{text}</h5>
    </div>
  );


return (

<section  className="iconsSection">

<div  className="allCards">

        <IconCard
          imgSrc="icons/smile-grey.gif"
          headline=" מבינים אנשים לא רק פיקסלים"
          headlineMaxWidth="170px"
          text="מבינים את העסק, הערכים והקהל ואז יוצרים"
           textMaxWidth="190px"
          />

      <IconCard
          imgSrc="icons/pencil-grey.gif"
         //  imgSrc="icons/render_icon-pencil-3d.gif"
          headline="קראייטיב מעל הכל"
          headlineMaxWidth="200px"
          text="AI הוא כלי. היצירתיות, הבחירות והדיוק -> שלנו"
           textMaxWidth="210px"
          />

    <IconCard
          imgSrc="icons/target-grey.gif"
          headline="ממוקדים במטרה"
          headlineMaxWidth="240px"
          text="אסטרטגיה חכמה. תוצאה אחת ברורה "
           textMaxWidth="180px"
          />

 
</div>

</section >
);
}

export default IconsSection;